import React from 'react';
import './image.scss';
import { useWindowSize } from '../../hooks/useWindowSize';
import { TABLET_WIDTH } from '../../constants/screenSizes';
import classNames from 'classnames';

interface IProps {
  src: string;
  altText?: string;
  objectPosition?: string;
  padding?: boolean;
}

export default function Image(props: IProps) {
  const { src, altText, objectPosition, padding } = props;
  const windowSize = useWindowSize();
  return (
    <div className="ui-image-container">
      <img
        loading="lazy"
        className={classNames('ui-image', { 'ui-image-padding': padding })}
        src={src}
        alt={altText}
        style={{
          objectPosition:
            objectPosition && windowSize.width > TABLET_WIDTH
              ? objectPosition
              : undefined,
        }}
      />
    </div>
  );
}
